module.exports = __webpack_public_path__ + "static/media/img2-2.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/diff/img2-2.png
// module id = 1271
// module chunks = 3